import React from "react";
import { Phone, MessageCircle, ShieldCheck, Award } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden"
    >
      {/* Ambient background accents */}
      <div className="pointer-events-none absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(30,95,217,0.18),transparent_60%)] blur-2xl" />
      <div className="pointer-events-none absolute -bottom-40 -right-40 h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(245,166,35,0.12),transparent_60%)] blur-2xl" />

      <div className="container-x grid lg:grid-cols-2 gap-12 lg:gap-16 items-center relative">
        {/* Image — appears first on mobile, left on desktop */}
        <div className="order-1 lg:order-1 reveal">
          <div className="relative rounded-2xl overflow-hidden border border-[var(--border-subtle)] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.25)]">
            <div className="aspect-[4/3] w-full">
              <img
                src="/images/hero-living.jpg"
                alt="Living modern renovat premium — Aurel Calin Premium"
                className="h-full w-full object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>

        {/* Copy — right on desktop */}
        <div className="order-2 lg:order-2 reveal">
          <div className="eyebrow mb-6">
            <span>Constanța & împrejurimi</span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display text-[var(--text-primary)] text-[2.4rem] sm:text-5xl lg:text-[3.6rem] leading-[1.05] font-medium"
          >
            Renovări construcții{" "}
            <span className="text-brand-blue italic">complete</span> case și
            apartamente
            <span className="text-brand-gold"> — </span>
            <span className="whitespace-nowrap">Constanța</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-[var(--text-secondary)] text-base md:text-lg max-w-xl"
          >
            <span className="text-[var(--text-primary)] font-semibold">14 ani experiență</span>
            <span className="dot" />
            <span className="text-[var(--text-primary)] font-semibold">Peste 400 de lucrări finalizate</span>
          </p>

          <p className="mt-4 text-[var(--text-muted)] text-sm md:text-base max-w-xl leading-relaxed">
            Executăm renovări la cheie, cu materiale premium, echipă proprie și
            termene respectate. De la gresie și gipscarton, până la amenajări
            complete de baie și fațade.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="tel:0746329111"
              data-testid="hero-call-btn"
              className="btn-gold justify-center"
            >
              <Phone className="h-4 w-4" strokeWidth={2.6} />
              Sună acum · 0746 329 111
            </a>
            <a
              href="https://wa.me/40746329111"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              className="btn-whatsapp justify-center"
            >
              <MessageCircle className="h-4 w-4" strokeWidth={2.4} />
              WhatsApp
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-5 md:gap-7">
            <div className="flex items-center gap-2 text-[var(--text-secondary)] text-sm">
              <ShieldCheck className="h-4 w-4 text-brand-gold" />
              Contract & garanție
            </div>
            <div className="hidden sm:block h-4 w-px bg-[var(--border-mid)]" />
            <div className="flex items-center gap-2 text-[var(--text-secondary)] text-sm">
              <Award className="h-4 w-4 text-brand-gold" />
              14 ani experiență
            </div>
            <div className="hidden sm:block h-4 w-px bg-[var(--border-mid)]" />
            <div className="flex items-center gap-2 text-[var(--text-secondary)] text-sm">
              <span className="star">★★★★★</span>
              <span>5.0 · recenzii clienți</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
